import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import * as PageLayout from 'layout/styles/PageLayout.style';
import * as Text from 'theme/components/Text.style';

export default function NotFound(): JSX.Element {
  const { t } = useTranslation('page404');
  return (
    <PageLayout.Page>
      <PageLayout.ContentContainer>
        <PageLayout.Content>
          <Text.H1>{t('page404.header')}</Text.H1>
          <Text.P2>{t('page404.description')}</Text.P2>
          <Text.P2>
            <Link to="/">{t('page404.link')}</Link>
          </Text.P2>
        </PageLayout.Content>
      </PageLayout.ContentContainer>
    </PageLayout.Page>
  );
}
